import { AxiosError } from 'axios';

export interface ApiError {
  code: string;
  name: string;
}

const errors: Record<string, string> = {
  INVALID_TWILIO_ACCOUNT_AUTH_TOKEN: 'Invalid twilio account auth token.',
  SUSPENDED_TWILIO_ACCOUNT: 'The provided twilio account is suspended.',
  TRIAL_TWILIO_ACCOUNT: 'The provided Twilio account cannot be a trial account.',
  TWILIO_ACCOUNT_ALREADY_EXISTS: 'The provided twilio account already exists.',
  SCOPE_KEYWORD_ALREADY_EXISTS: 'This keyword is already being used by another Scope of this App.',
  APP_CODE_ALREADY_EXISTS: 'This App Code is already being used by another App.',
};

export const getApiErrorMessage = (
  error: AxiosError<ApiError>,
  defaultMessage = 'There was an error, please try again later',
): string => {
  if (error.response?.data?.code) {
    return errors[error.response.data.code] || defaultMessage;
  }

  return defaultMessage;
};
